import { moduleNames, OperationScope } from "./dashboardModuleNames";
import moment from "moment";

export const renderChartTitle = (
  moduleName,
  operationScope,
  startDate,
  endDate = null,
  clusterCode = null,
  areaCode = null,
  branchCode = null,
  isRunningBalance = true
) => {
  var specifier = "for the date of";

  if (!endDate) {
    endDate = startDate;
  }

  const formatDates = (date, format) => moment(date).format(format);

  const formatEndDate = formatDates(endDate, "MMMM DD YYYY");
  const formatStartDate = formatDates(startDate, "MMMM DD YYYY");

  // Only month and year
  const MonthYearformatStartDate = formatDates(startDate, "MMMM YYYY");
  const MonthYearformatEndDate = formatDates(endDate, "MMMM YYYY");

  const rangeDatesEqual = formatEndDate === formatStartDate;
  const rangeMonthDatesEqual = MonthYearformatStartDate && MonthYearformatEndDate;
  const dateRange = formatStartDate !== formatEndDate;

  if (rangeDatesEqual) {
    if (
      [
        moduleNames.packages,
        moduleNames.unredeemedPawns,
        moduleNames.customerProfiling,
        moduleNames.inventoryTarget,
        moduleNames.salesAverage,
        moduleNames.salesActive,
        moduleNames.salesExpired,
        moduleNames.branchCategory,
      ].includes(moduleName)
    ) {
      specifier = isRunningBalance ? "for" : "for the date of";
    }
  }

  const moduleNameMap = {
    [moduleNames.packages]: "Packages",
    [moduleNames.ranking]: "Ranking",
    [moduleNames.salesActive]: "Active Sales",
    [moduleNames.salesAverage]:
      "Comparative View of Year to Year and Month to Month Average Pawns",
    [moduleNames.salesExpired]: "Expired Sales",
    [moduleNames.unredeemedPawns]: "Unredeemed Pawns",
    [moduleNames.inventoryTarget]:
      "Comparative View of Active Inventory versus Target Inventory",
    [moduleNames.customerProfiling]: "Customer Profiles",
    [moduleNames.branchCategory]: "Branch Categories",
  };

  const endModuleName = moduleNameMap[moduleName] || "No Module";

  const operationMap = {
    [OperationScope.overall]: "Overall",
    [OperationScope.specifiedCluster]: clusterCode,
    [OperationScope.specifiedArea]: areaCode,
    [OperationScope.specifiedBranch]: branchCode,
  };

  const operation = operationMap[operationScope] || "Overall";

  // Pawns Target Date range
  if (rangeMonthDatesEqual && moduleName === moduleNames.inventoryTarget) {
    return `${endModuleName} from ${MonthYearformatStartDate} to ${MonthYearformatEndDate} for ${operation}`;
  }
  //  Pawns Average for Month and Year
  else if (rangeDatesEqual && moduleName === moduleNames.salesAverage) {
    return `${endModuleName} as of ${MonthYearformatEndDate} for ${operation}`;
  }
  //Covered Date
  else if (isRunningBalance && !dateRange) {
    return `${endModuleName} ${specifier} ${formatEndDate} for ${operation}`;
  } else {
    return `${endModuleName} from ${formatStartDate} to ${formatEndDate} for ${operation}`;
  }
};
